interface CoreEurekaPricingOptions {
    pricingRange?: 'five';
    triggerSource?: 'side_nav' | 'agent_home' | 'paywall';
    agentName?: string;
    /**
     * 控制弹窗 header 展示类型：
     * - `pricing_proactive_view` 用户主动点击 Upgrade / Pricing / Plans 入口
     * - `feature_upgrade_required` 用户访问当前版本不可用的高级功能
     * - `credits_limit_upgrade` 用户 Credits 已用完
     */
    headerType?: 'pricing_proactive_view' | 'feature_upgrade_required' | 'credits_limit_upgrade'
}

export function getCoreEurekaPricingUrl(redirectUrl?: string, options?: CoreEurekaPricingOptions) {
    const coreEurekaUrl = import.meta.env.VITE_EUREKA_URI as string;

    const entries: Record<string, string | undefined> = {
        'upgrade-from': redirectUrl || window.location.href,
        product_line: 'eureka_ls',
        'price-range': options?.pricingRange,
        trigger_source: options?.triggerSource,
        agent_name: options?.agentName,
        header_type: options?.headerType,
    };
    const params = new URLSearchParams(
        Object.entries(entries).filter((e): e is [string, string] => e[1] !== undefined)
    );
    return `${coreEurekaUrl}/credits-price?${params.toString()}`;
}
/**
 * 重定向到Core Eureka的Pricing页面
 * @param redirectUrl 返回的页面，默认是跳转前的页面
 * @returns
 */
export function redirectToCoreEurekaPricing(redirectUrl?: string, options?: CoreEurekaPricingOptions) {
    window.location.href = getCoreEurekaPricingUrl(redirectUrl, options);
}
